import {AxiosError, AxiosResponse} from 'axios';
import {get} from 'lodash-es';
import {Store} from 'redux';

import * as enums from '../enums';
import {middlewareResponseErrorInterceptor} from './middleware.responseErrorInterceptor';

/**  Besides the isPillarDown check, the rest of the logic is explicitly used for TdmMw and SentinelMw Legacy Api EC_XXXX codes */
export function middlewareResponseInterceptor(
    store: Store,
    response: AxiosResponse
): Promise<AxiosResponse> | Promise<AxiosError> {
    const state = store.getState();

    const errorDetails = get(response, 'data.errorDetails', []);
    const isAuthError = errorDetails.some(({errorCode}) =>
        ['EC_2002', 'EC_2003'].includes(errorCode)
    );
    const isUnAuthorizedError = errorDetails.some(
        ({errorCode}) => errorCode === 'EC_2004'
    );
    const config = response.config as typeof response.config & {
        isPillarSource?: boolean;
    };
    const isPillarDown =
        Boolean(config.isPillarSource) &&
        !state.pillarStatus[state.platform.mic];

    if (isPillarDown) {
        return middlewareResponseErrorInterceptor(
            store,
            new AxiosError(
                enums.PILLAR_OFFLINE,
                'ECONNABORTED',
                response.config,
                response.request,
                response
            )
        );
    }

    if (isAuthError) {
        return middlewareResponseErrorInterceptor(
            store,
            new AxiosError(
                enums.INVALID_ACCESS_TOKEN,
                'ECONNABORTED',
                response.config,
                response.request,
                {
                    ...response,
                    status: 401
                }
            )
        );
    }

    if (isUnAuthorizedError) {
        return middlewareResponseErrorInterceptor(
            store,
            new AxiosError(
                enums.UNAUTHORIZED_ACCESS,
                'ECONNABORTED',
                response.config,
                response.request,
                {
                    ...response,
                    status: 403
                }
            )
        );
    }

    if (errorDetails.length > 0) {
        return middlewareResponseErrorInterceptor(
            store,
            new AxiosError(
                enums.DEFAULT,
                'ECONNABORTED',
                response.config,
                response.request,
                response
            )
        );
    }

    return Promise.resolve(response);
}
